interface SelectionBubbleProps {
  isFixed?: boolean;
  isOutOfViewBelow?: boolean;
  onScrollToSelection?: () => void;
  onPlayFromSelection: () => void;
  onCopySelection: () => void;
  onClearSelection: () => void;
}

export default function SelectionBubble({
  isFixed = false,
  isOutOfViewBelow = false,
  onScrollToSelection,
  onPlayFromSelection,
  onCopySelection,
  onClearSelection,
}: SelectionBubbleProps) {
  return (
    <div
      onClick={isFixed ? onScrollToSelection : undefined}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px',
        background: '#fff',
        borderRadius: '24px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
        zIndex: 10,
        whiteSpace: 'nowrap',
        cursor: isFixed ? 'pointer' : 'default',
      }}
    >
      {isFixed && (
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            color: 'var(--primary-soft)',
            marginLeft: '4px',
            transform: isOutOfViewBelow ? 'rotate(180deg)' : 'none',
          }}
        >
          <path d="M12 19V5M5 12l7-7 7 7" />
        </svg>
      )}
      {/* Play button - accent background with play icon */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onPlayFromSelection();
        }}
        style={{
          width: '32px',
          height: '32px',
          background: 'var(--accent)',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-label="Play from selection"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="#fff"
          stroke="none"
        >
          <polygon points="6 3 20 12 6 21 6 3" />
        </svg>
      </button>
      {/* Copy button - icon only */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onCopySelection();
        }}
        style={{
          width: '32px',
          height: '32px',
          background: 'transparent',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-label="Copy selection"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--primary-soft)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      </button>
      {/* Close button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClearSelection();
        }}
        style={{
          width: '32px',
          height: '32px',
          background: 'transparent',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-label="Clear selection"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--primary-soft)"
          strokeWidth="2"
        >
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
